<template>
  <div class="page-frame" v-if="pageData" role="main">
    <div class="container">
      <div v-if="pageData.acf && pageData.acf['header_image']" class="header-image" role="banner">
        <v-img
          v-bind:src="pageData.acf['header_image'].url"
          v-bind:alt="pageData.acf['header_image'].alt"
          aspect-ratio="3"
        ></v-img>
      </div>
      <h1
        class="page-title"
        v-if="pageData.acf && pageData.acf['display_page_title']"
        role="banner"
      >{{pageData.title.rendered}}</h1>
      <v-layout wrap>
        <v-flex xs12 sm12 md8>
          <div v-html="pageData.content.rendered"></div>
        </v-flex>
        <v-flex xs12 sm12 md4>
          <div>
            <iframe
              :title="$t('FACEBOOK_IFRAME_TITLE')"
              src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Ffundacjawielozmysly%2F&tabs&width=320&height=214&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=400342967278074"
              width="320"
              height="214"
              style="border:none;overflow:hidden"
              scrolling="no"
              frameborder="0"
              allowtransparency="true"
              allow="encrypted-media"
            ></iframe>
          </div>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
export default {
  name: "Contact",
  props: {
    pageData: Object,
    contrastMode: Boolean
  }
};
</script>